import reducer from './reducers';

export { default as filesMetaSelectors } from './selectors';
export { default as filesMetaOperations } from './operations';
export { default as filesMetaTypes } from './types';

export default reducer;
